import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-semibold mb-3">Finančný Pokoj</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Kompletný systém pre tvoje financie. Ebook dostupný v PDF, EPUB a MOBI formáte za 5,99 €.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms-and-conditions" className="text-gray-400 hover:text-white transition-colors">Terms and Conditions</Link></li>
              <li><Link to="/refund-policy" className="text-gray-400 hover:text-white transition-colors">Refund Policy</Link></li>
              <li><Link to="/ochrana-sukromia" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/zmluvne-podmienky" className="text-gray-400 hover:text-white transition-colors">Zmluvné podmienky</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-3">Contact</h3>
            <div className="text-gray-400 text-sm space-y-1">
              <p>Wavelyne SINGLE MEMBER P.C.</p>
              <p>Leof. Andrea Siggrou 196</p>
              <p>Kallithea 176 71, Athens</p>
              <p>VAT: EL802952696</p>
              <p className="mt-2">
                <a href="mailto:diana@wavelynecode.com" className="hover:text-white transition-colors">
                  diana@wavelynecode.com
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Wavelyne SINGLE MEMBER P.C. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
